import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=2859bc62&scoped=true&lang=pug"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"
import style0 from "./Share.styl?vue&type=style&index=0&id=2859bc62&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859bc62",
  null
  
)

export default component.exports